<template>
  <b-btn
    class="action-btn"
    :to="to"
    :variant="variant"
    v-b-tooltip="{hover: true, top: true, title: title, boundary: 'window'}"
  >
    <i
      class="fa"
      :class="'fa-' + icon"
    />
  </b-btn>
</template>

<script>
export default {
  name: 'ActionBtn',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    to: null,
    variant: { type: String, default: 'secondary' },
  },
};
</script>

<style scoped>
  .action-btn {
    margin: 0px !important;
    padding: 4px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
    font-size: 10px;
  }
</style>
